import {EmailSourceDto} from '../../domain/EmailSourceDto';
import "./EmailSourceView.scss";
import {HideContentButton} from '../common/HideContentButton';

export const EmailSourceView = ({emailSource}: { emailSource: EmailSourceDto }) => {
    return (<>
        <div className="email-source-button">
            <HideContentButton/>
        </div>
        {emailSource.Decoded ? (
            <div className="email-source" dangerouslySetInnerHTML={{__html: emailSource.Source}}>
            </div>
        ) : (
            <div className="email-source">
                <pre>
                    {emailSource.Source}
                </pre>
            </div>
        )}
    </>);
};
